var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuestionBase',{attrs:{"showQuestion":false,"question":_vm.question,"errors":[..._vm.errorsPost, ..._vm.serverErrors, ..._vm.jsErrors],"valid":!!_vm.data,"disabled-valid":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }